import Store from 'store/store';
import { visibleRatio } from 'utils/visibilityChecks';
import { fire, getVariables } from 'store/bolt/trackingV2';

Store.on('UPDATE_HUB_ACTIVE_PERCENTAGE', () => {
	let elem = document.querySelector('[data-attribute=boltHubPageHero]');
	let percentage = visibleRatio(elem);
	let store = Store.get();
	if (percentage === undefined) {
		return store.set({ hubActivePercentage: 0 });
	}
	store.set({ hubActivePercentage: percentage });
});

Store.on('UPDATE_VISIBILITY_PERCENTAGES', () => Store.emit('UPDATE_HUB_ACTIVE_PERCENTAGE')); // this is responsible for updating the perc on scroll

Store.on('HUB_TEXT_OVERLAY_SHOW', (bool) => {
	Store.get().header.set({ hubTextOverlayOpen: bool });
});

Store.on('CAROUSEL_TEXT_OVERLAY_SHOW', (id) => {
	Store.get().hub.set({ carouselWithTextOverlayOpen: id });
});

Store.on('HUB_HERO_ENGAGEMENT_TILE_CLICKED', ({ tileTitle, destination }) => fire('hubHeroEngagementTileClicked', getVariables({ tileTitle, destination })));
Store.on('HUB_HERO_ENGAGEMENT_CTA_CLICKED', ({ buttonLabel, destination }) => fire('hubHeroEngagementCTAClicked', getVariables({ buttonLabel, destination })));
Store.on('HUB_HERO_CAROUSEL_ENGAGEMENT_TILE_CLICKED', ({ tileTitle, destination }) => fire('hubHeroCarouselEngagementTileClicked', getVariables({ tileTitle, destination })));
Store.on('HUB_HERO_CAROUSEL_ENGAGEMENT_CTA_CLICKED', ({ tileTitle, buttonLabel, destination }) => fire('hubHeroCarouselEngagementCTAClicked', getVariables({ tileTitle, buttonLabel, destination })));
Store.on('HUB_CAROUSEL_ENGAGEMENT_TILE_CLICKED', ({ carouselTitle, tileTitle, destination }) => fire('hubCarouselEngagementTileClicked', getVariables({ carouselTitle, tileTitle, destination })));
Store.on('HUB_CAROUSEL_ENGAGEMENT_CTA_CLICKED', ({ carouselTitle, tileTitle, buttonLabel, destination }) => fire('hubCarouselEngagementCTAClicked', getVariables({ carouselTitle, tileTitle, buttonLabel, destination })));
Store.on('HUB_CAROUSEL_ENGAGEMENT', ({ carouselTitle }) => fire('hubCarouselEngagement', getVariables({ carouselTitle })));
